module.exports = __webpack_public_path__ + "img/add-image1.1418ef4c.png";